const fromdataedit = [
{
		inputdata: '',
		title: '产品线编码',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
	},
	{
		inputdata: '',
		title: '产品线名称',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		lablewith: '90px',

	},
	{
		inputdata: true,
		title: '是否唯一码管理',
		fontSize: '14px',
		color: '#333333',
		placeholder: '',
		types: '',
		inputtype: 'checkboxs',
		checkboxdata: [{
			label: "1",
			value: ""
		}],
		width: '',
		lablewith: '150px',
	},
	{
		inputdata: '',
		title: '父级编码',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'select',
		width: '220px',
		btx: true,
		lablewith: '90px',
		options: []
	},
	]
export default fromdataedit;
